export default __webpack_public_path__ + "static/media/oca.3716c424.png";